import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from 'src/environments/environment';
import { Response } from '@shared/interfaces/response/response';
import { FormPermission } from '@pages/modules-permission/interfaces/FormPermission';

const httpOption = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
  }),
};

@Injectable({
  providedIn: 'root'
})
export class FormsService {
  private _url = environment.apiBaseUrl + 'api/FormPermission';
  constructor(private _http: HttpClient) {}

  read(): Observable<Response> {
    return this._http.get<Response>(this._url);
  }

  readControls(): Observable<Response> {
    let url: string = this._url + '/GetControls' ;
    return this._http.get<Response>(url);
  }

  readOne(moduleName: string): Observable<Response> {
    let url: string = this._url + moduleName ;
    return this._http.get<Response>(url);
  }

  create(model: FormPermission): Observable<Response> {
    let url: string = this._url + '/Create' ;
    return this._http.post<Response>(url, model, httpOption);
  }

  update(model: FormPermission): Observable<Response> {
    let url: string = this._url + '/Update' ;
    return this._http.post<Response>(url, model, httpOption);
  }

  delete(model: FormPermission): Observable<Response> {
    let url: string = this._url + '/Delete' ;
    return this._http.request<Response>('delete', url, {
      body: model,
    });
  }
}
